module.exports = __webpack_public_path__ + "static/media/malestised.13f8b4d5.png";